import { Trans } from 'react-i18next';
import VideoPoster from '../../assets/2.jpg';
import Video from '../../assets/2.mp4';
import { FrameLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { H10, SubH1 } from '../../common/common-text';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useAnalytics } from '../../hooks/useAnalytics';
import { useDeviceType } from '../../hooks/useDeviceType';
import useVisualViewportHeight from '../../hooks/useVisualViewportHeight';

const SecondaryBatterySection1 = () => {
  const { horizontal: padding, topSectionBottom: topSectionBottom } = useResponsivePadding(/*{ mode: 'fixed' }*/);
  const viewheight = useVisualViewportHeight();
  const { isMobile, isPad } = useDeviceType();
  const { trackVideoPlay } = useAnalytics();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  return (
    <VerticalLayout style={{
      background: 'black',
      ...(isMobile && !isPad ? { height: viewheight } : {}),
    }}>
      <FrameLayout>
        <video
          src={Video}
          autoPlay
          muted
          loop
          playsInline
          poster={VideoPoster}
          onPlay={() => trackVideoPlay('이차전지', 'secondary_battery', 0)}
          style={{
            width: '100%',
            height: isMobile && !isPad ? '100%' : 'auto',
            display: 'block',
            objectFit: 'cover',
          }}
        />
        <SubH1 style={{
          color: 'white',
          position: 'absolute',
          bottom: (isMobile && !isPad) ? isEng ? '224px' : isChina ? '119px' : '141px' : `${topSectionBottom}px`,
          left: `${padding}px`,
          width: isMobile ? '90%' : '50%',
          transform: isPad ? 'scale(0.80)' : 'scale(1)',
          transformOrigin: 'left bottom',
        }}>{isMobile
          ? 'Lithium-Ion Battery Main Utility & Process Piping'
          : <>Lithium-Ion Battery<br />Main Utility &<br />Process Piping</>}</SubH1>
        <H10
          style={{
            width: isMobile && !isPad ? `calc(100% - ${padding * 2}px)` : pxToRem(510),
            color: 'white',
            position: 'absolute',
            bottom: isMobile && !isPad ? '0px' : `${topSectionBottom}px`,
            left: isMobile && !isPad ? `${padding}px` : undefined,
            right: isMobile && !isPad ? undefined : `${padding}px`,
            transform: isPad ? 'scale(0.85)' : 'scale(1)',
            transformOrigin: 'right bottom',
            ...(isMobile && !isPad
              && { height: isEng ? '212px' : isChina ? `102px` : `124px` }),
            ...isChina ? {wordBreak: 'break-word'} : {}
          }}
        >
          <Trans i18nKey='극한의 조건에서도 정밀하게 작동하는 배관 시스템과 생산 설비 기술을 바탕으로, 2차전지 제조 현장의 신뢰성과 효율을 극대화하고, 전기차·ESS·모바일 디바이스 등 다양한 산업의 에너지 혁신을 기술로 지원합니다.' />
        </H10>
      </FrameLayout>
    </VerticalLayout>
  );
};

export default SecondaryBatterySection1;
